import { useTheme } from '@mui/material';
import { AlarmPriority } from 'src/types/alarms';
import { StyledLabelTagBox, StyledLabelTagValue } from './style';

type Props = {
  alarmPriority: AlarmPriority;
  value: number;
};

export const LabelTagBox = ({ alarmPriority, value }: Props) => {
  const theme = useTheme();

  const backgroundColors = {
    Critical: theme.palette.error.lighter,
    Warning: theme.palette.warning.lighter,
    Info: theme.palette.info.lighter,
    Cleared: theme.palette.success.lighter,
    null: theme.palette.grey[300],
  };

  const colors = {
    Critical: theme.palette.error.main,
    Warning: theme.palette.warning.main,
    Info: theme.palette.info.main,
    Cleared: theme.palette.success.main,
    null: theme.palette.grey[500],
  };

  const borderColor = alarmPriority === 'null' ? 'transparent' : colors[alarmPriority];

  return (
    <StyledLabelTagBox background={backgroundColors[alarmPriority]} color={borderColor}>
      <StyledLabelTagValue color={colors[alarmPriority]}>{value}</StyledLabelTagValue>
    </StyledLabelTagBox>
  );
};
